<template>
  <div class="esv ma-3">
    <span class="text-h5 my-5">Copy Document</span>
    <v-card outlined class="mt-2">
      <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
        Selected Source Document
        <v-spacer></v-spacer>
        <v-btn icon @click="reset">
          <v-icon>mdi-autorenew</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="2"><span class="text-subtitle-2 pr-1">Type</span></v-col>
          <v-col cols="2">
            <span class="text-subtitle-2 px-1">Dossier</span>
          </v-col>
          <!-- <v-col cols="1"></v-col> -->
          <v-col cols="1" offset="1">
            <span class="text-subtitle-2 px-1" v-if="isFieldVisibleSourceDocument('VersionSourceDocument')">Version</span>
          </v-col>
          <v-col cols="1">
            <span class="text-subtitle-2 px-1">Revision</span>
          </v-col>
          <v-col cols="5">
            <span class="text-subtitle-2 pl-1">Subject</span>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-2">
          <v-col cols="2">
            <c-select
              class="pr-1"
              v-model="original.serviceRequestTypeId"
              :items="serviceRequestTypes"
              @input="getDossiers"
              :readonly="readonly"
            ></c-select>
          </v-col>
          <v-col cols="2">
            <c-autocomplete
              class="px-1"
              v-model="original.dossier"
              :items="dossiers"
              @input="getVersions"
              :readonly="readonly"
            ></c-autocomplete>
          </v-col>
          <v-col cols="1" class="font-weight-black px-1 pt-2"> - </v-col>
          <v-col cols="1">
             <template>
              <c-select
                v-if="isFieldVisibleSourceDocument('VersionSourceDocument')"
                class="px-1"
                v-model="original.version"
                :items="versions"
                @input="getRevisions"
                :readonly="readonly"
              ></c-select>
            </template>
          </v-col>
          <v-col cols="1">
            <c-select
              class="px-1"
              v-model="original.revision"
              :items="revisions"
              @input="getTitleForRevision"
              :disabled="isRnsSourceDocument"
              :readonly="readonly"
            ></c-select>
          </v-col>
          <v-col cols="5">
            <c-text-field
              class="pl-1"
              v-model="original.subject"
              readonly
            ></c-text-field>
          </v-col>
        </v-row>
        <v-btn
          color="primary"
          small
          class="mr-2"
          @click="copyAsNewRevision"
          :loading="loading.newRevision"
        >
          Copy as new revision
        </v-btn>
        <v-btn
          color="primary"
          small
          class="mr-2"
          :disabled="isRnsSourceDocument"
          @click="copyAsNewRevisionWithFollowUp"
          :loading="loading.newRevisionWithFollowUp"
        >
          Copy as new revision with execution follow up
        </v-btn>
        <v-btn
          outlined
          small
          class="mr-2"
          :disabled="isRnsSourceDocument"
          @click="selectNewVersionNumber"
          :loading="loading.newVersion"
        >
          Copy as new version
        </v-btn>
      </v-card-text>
    </v-card>
    <v-card outlined v-if="original.id" class="mt-2">
      <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
        Copy As new Service Reference
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid">
          <v-row no-gutters>
            <v-col cols="2">
              <span class="text-subtitle-2 pr-1">Type</span>
            </v-col>
            <v-col cols="2">
              <span class="text-subtitle-2 px-1">Dossier</span>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="1">
              <span class="text-subtitle-2 px-1" v-if="isFieldVisibleTargetDocument('VersionTargetDocument')">Version</span>
            </v-col>
            <v-col cols="1"><span class="text-subtitle-2 px-1">Revision</span></v-col>
            <!-- <v-col cols="6"><span class="text-subtitle-2">Subject</span></v-col> -->
          </v-row>
          <v-row no-gutters class="mb-2">
            <v-col cols="2">
              <!-- <v-text-field v-model="model.serviceRequestTypeDescription" outlined dense label="Type"></v-text-field> -->
              <v-select
                autofocus
                class="pr-1"
                hide-details="auto"
                v-model="originalRelated.serviceRequestTypeId"
                :items="serviceRequestTypes"
                label="Service Request Type"
                outlined
                dense
                :rules="[$common.rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-text-field
                class="px-1"
                hide-details="auto"
                v-model="originalRelated.dossier"
                outlined
                dense
                :disabled="isRnsTargetDocument"
                :label="dossierLabel"
                :rules="[$common.rules.dossier]"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="font-weight-black px-1 pt-2">-</v-col>
              <v-col cols="1">                
                <v-text-field
                  v-if="isFieldVisibleTargetDocument('VersionTargetDocument')"
                  class="px-1"
                  v-model="originalRelated.version"
                  outlined
                  dense
                  label="Version"
                  @input="getNextRevisionForNewServiceReference"
                ></v-text-field>
              </v-col>
            <v-col cols="1">
              <v-text-field 
                v-model="originalRelated.revision" 
                class="ml-1" outlined dense label="Revision" readonly disabled
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <!-- <v-text-field v-model="model.subject" outlined dense label="Subject" readonly></v-text-field> -->
            </v-col>
          </v-row>
        </v-form>

        <v-btn
          outlined
          small
          @click="copyAsServiceRequest"
          :disabled="!isRnsTargetDocument && !valid"
          :loading="loading.newServiceRequest"
        >
          Copy as new service request type
        </v-btn>
      </v-card-text>
    </v-card>
    <v-switch
      v-model="useSPCopy"
      label="Copy via SP"
      class="mt-6 ml-2"
      v-if="$can('Copy', 'StoredProcedure')"
    ></v-switch>
    <v-dialog v-model="newVersionDialog" max-width="600px">
      <v-card>
        <v-card-title>
          Select new version
        </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="this.original.dossier"
                  label="Dossier"
                  class="required"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  label="Version"
                  v-model="newVersion"
                  :items="newVersions"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="copyAsVersion">Copy as new version</v-btn>
            <v-btn color="white" @click="newVersionDialog = false">Close and return</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
//import { version } from 'vue/types/umd';
// @ is an alias to /src

export default {
  name: "Copy",
  components: {},
  props: {
    id: [String, Number],
  },
  data: () => ({
    useSPCopy: false,
    original: {
      serviceRequestTypeId:null
    },
    originalRelated:{
      serviceRequestTypeId: null,
      dossier: '',
      version: '',
      revision: ''
    },
    model: {},
    readonly: false,
    valid: true,

    newVersionDialog: false,
    newVersion: null,
    newVersions: [],


    serviceRequestTypes: [],
    dossiers: [],
    versions: [],
    revisions: [],
    versionsTargetDocument: [],
    revisionsTargetDocument: [],

    copyType: {
      newRevision: 1,
      newRevisionWithFollowUp: 5,
      newVersion: 2,
      newServiceRequest: 3,
    },
    loading: {
      newRevision: false,
      newRevisionWithFollowUp: false,
      newVersion: false,
      newServiceRequest: false,
    },
  }),
  created() {
    this.getCopyViewModel();
    this.getServiceRequestTypes();
  },
  methods: {
    isFieldVisibleSourceDocument(fieldName) {
      const fullFieldName = `Input.Copy.${fieldName}`;
      return this.$common.isFieldVisible(this.$store, this.original, fullFieldName);
    },
    isFieldVisibleTargetDocument(fieldName) {
      const fullFieldName = `Input.Copy.${fieldName}`;
      return this.$common.isFieldVisible(this.$store, this.originalRelated, fullFieldName);
    },
    getGeneratedDossierForRns() {
    if (this.originalRelated.serviceRequestTypeId) {
      this.$api
        .generateDossierForRns(this.originalRelated.serviceRequestTypeId)
        .then((resp) => {
          this.originalRelated.dossier = String(resp.data);
        })
        .catch((error) => {
          console.error('Error generating dossier:', error);
        });
    }
  },
    setDropdownItems() {
      this.dossiers = [this.original.dossier];
      this.versions = [this.original.version];
      this.revisions = [this.original.revision];
    },
    getCopyViewModel() {
      // console.log(!!this.id);
      if (this.id) {
        this.readonly = true;
        this.$api.getCopyViewModel(this.id).then((resp) => {
          this.original = resp.data;
          this.setDropdownItems();
        });
      }
    },
    getServiceRequestTypes() {
      this.$api
        .getServiceRequestTypes()
        .then((resp) => (this.serviceRequestTypes = resp.data));
    },

    getDossiers() {
      this.original = {
        serviceRequestTypeId: this.original.serviceRequestTypeId,
      };
      this.$api
        .getDossierNumbersForServiceRequestType(
          this.original.serviceRequestTypeId
        )
        .then((resp) => (this.dossiers = resp.data));
    },
    getVersions() {
      this.original = {
        serviceRequestTypeId: this.original.serviceRequestTypeId,
        dossier: this.original.dossier,
      };
      this.$api.getVersionsForDossier(this.original).then((resp) => {
        this.versions = resp.data;
        if (this.versions.length === 1) {
          this.original.version = this.versions[0];
          this.getRevisions();
        }
      });
    },
    getVersionForTargetDocument() {
      this.originalRelated = {
        serviceRequestTypeId: this.originalRelated.serviceRequestTypeId,
        dossier: this.originalRelated.dossier,
      };
      this.$api.getVersionsForDossier(this.originalRelated).then((resp) => {
        this.versionsTargetDocument = resp.data;
        if (this.versionsTargetDocument.length === 1) {
          this.originalRelated.version = this.versionsTargetDocument[0];
          this.getRevisionForTargetDocument();
        }
      });
    },
    getRevisions() {      
      this.original = {
        serviceRequestTypeId: this.original.serviceRequestTypeId,
        dossier: this.original.dossier,
        version: this.original.version
      };
      this.$api.getRevisionsForDossier(this.original).then((resp) => {
        this.revisions = resp.data;
        // if (this.revisions.length > 0) {
          // this.original.revision = this.revisions[this.revisions.length - 1];
          this.getLatestRevision();
        // }
        // else {
          // this.getLatestRevision();
        // }
      });
    },
    getRevisionForTargetDocument() {      
      this.originalRelated = {
        serviceRequestTypeId: this.originalRelated.serviceRequestTypeId,
        dossier: this.originalRelated.dossier,
        version: this.originalRelated.version
      };
      this.$api.getRevisionsForDossier(this.originalRelated).then((resp) => {
        this.revisionsTargetDocument = resp.data;
          this.getNextRevisionForNewServiceReference();
      });
    },

    getLatestRevision() {
      this.$api.getLatestRevisionForCopy(this.original).then((resp) => {
        this.original = resp.data;
        this.model.serviceRequestTypeId = this.original.serviceRequestTypeId;
        // this.setDropdownItems();
      });
    },
    getNextRevisionForNewServiceReference() {
      this.originalRelated.revision = null;
      if (this.originalRelated.version !== '' && this.originalRelated.version !== '0') {					
        this.$api.getNextRevisionForCopyForNewReference(this.originalRelated)
          .then((resp) => {
            if (!resp.data) return;
            this.originalRelated.version = resp.data.version;
            this.originalRelated.revision = resp.data.revision;
          });
      }
    },
    getTitleForRevision() {
      this.$api.getTitleForRevision(this.original).then((resp) => {
        this.original = resp.data;
        this.model.serviceRequestTypeId = this.original.serviceRequestTypeId;
        // this.setDropdownItems();
      });
    },
    copyAsNewRevision() {
      this.original.copyType = 1;
      this.copy(this.original, "newRevision");
    },
    copyAsNewRevisionWithFollowUp() {
      this.original.copyType = 5;
      this.copy(this.original, "newRevisionWithFollowUp");
    },
    selectNewVersionNumber(){
      this.$api.getAvailableVersionNumbers(this.original).then((resp) => {
        this.newVersions = resp.data;
        this.newVersionDialog = true;
      });
    },
    copyAsVersion() {
      this.original.copyType = 2;
      this.original.newVersion = this.newVersion;
      this.copy(this.original, "newVersion");
    },
    copyAsServiceRequest() {
      this.model.id = this.original.id;														
      this.model.copyType = 3;
      this.model.serviceRequestTypeId = this.originalRelated.serviceRequestTypeId;			
      this.model.revision = this.originalRelated.revision;
      if (this.model.serviceRequestTypeId == 24) {
        this.model.dossier = "1111111";
      } else {
        this.model.dossier = this.originalRelated.dossier;
      }
      this.model.version = this.originalRelated.version;
      this.copy(this.model, "newServiceRequest");
    },
    copy(model, loader) {
      this.loading[loader] = true;
      this.$api
        .copy(model, this.useSPCopy)
        .then(resp => this.$router.push({ name: "ESV", params: { esvId: resp.data } }))
        .finally(() => (this.loading[loader] = false));
    },

    checkForValidVersion(){
      if(this.model.version < 1){
        this.model.version = null;
      }
    },
    resetFieldsOriginalRelated() {
      this.originalRelated.serviceRequestTypeId = '';
      this.originalRelated.dossier = '';
      this.originalRelated.version = '';
      this.originalRelated.revision = '';
    },
    reset() {
      this.readonly = false;
      this.original = {};
      this.originalRelated = {};
    },
  },
  watch: {
    'originalRelated.dossier'() {
      if (this.originalRelated.serviceRequestTypeId === 24) {
      this.originalRelated.version = '99'; // Set default version to 99
    } else {
      this.originalRelated.version = null; // Set version to null for other types
    }
      //this.originalRelated.version = null;
      this.originalRelated.revision = null;
    },
    'original.serviceRequestTypeId'() {
        this.resetFieldsOriginalRelated();
       },
    'originalRelated.serviceRequestTypeId'(newValue) {
      if (newValue === 24) {
        this.originalRelated.dossier='';
        this.originalRelated.version='99';
        this.$toast.info('The File No. (Dossier) will be generated automatically.');
      } else {
        this.originalRelated.dossier = '';
        this.originalRelated.version ='';
      }
    },
  },
  computed: {
    isRnsSourceDocument() {
      return this.original.serviceRequestTypeId == 24;
    },
    isRnsTargetDocument() {
      return this.originalRelated.serviceRequestTypeId == 24;
    },
    dossierLabel() {
    if (this.originalRelated.serviceRequestTypeId === 24) {
      return 'Dossier (Auto-Generated)';
    }
    return 'Dossier';
  },
  },
};
</script>

<style scoped>
.v-input--checkbox >>> label {
  color: black;
  /* font-size: 14px; */
}

.required >>> fieldset {
  border-left: 3px solid dodgerblue;
}

.dotted >>> fieldset {
  border-left: 3px dotted dodgerblue;
}
</style>